import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    
    if (res.code !== 200) {
      Message.error(res.message || '请求失败');
      
      // Token 过期
      if (res.code === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        router.push('/login');
      }
      
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    
    return res;
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      Message.error('登录已过期，请重新登录');
      router.push('/login');
      return Promise.reject(error);
    }
    Message.error(error.message || '网络错误');
    return Promise.reject(error);
  }
);

export default request;

// 线上服务器地址，开发环境（localhost）时用于拼接图片 URL
// 备案期间用 HTTP + IP，备案通过后改回 https://lanfengdu.top
const ONLINE_URL = 'http://82.157.160.195'

/**
 * 将服务端返回的图片路径转为可访问 URL
 * - 如果已经是完整 URL（http/https/data:）则直接返回
 * - 如果是相对路径（/uploads/xxx）：
 *   开发环境（localhost）：拼接线上地址，因为本地没有图片资源
 *   生产环境：直接返回相对路径，由 Nginx 同源代理访问
 * - 如果为空则返回空字符串
 */
export function getImageUrl(path) {
  if (!path) return ''
  if (path.startsWith('http') || path.startsWith('data:')) return path
  // 开发环境：拼接线上地址（因为本地没有图片资源）
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return ONLINE_URL + path
  // 生产环境：直接返回相对路径，由 Nginx 同源代理访问
  return path
}
